import { ThemeEvents } from '@theme/events';

// The Afterpay on-site messaging app block ships its own update script that watches for variant
// changes via a PerformanceObserver on network requests. However, it only triggers when the
// request URL contains a `variant` parameter, whereas this theme's variant-picker fetches
// updated sections using `option_values` instead. As a result the app's observer never fires
// and the instalment amount shown by <square-placement> goes stale after a variant switch.
//
// This module fills that gap by listening for the theme's own `variant:update` event and
// updating the `data-amount` attribute directly. The <square-placement> web component
// re-renders itself whenever that attribute changes, which is the same mechanism the app's
// own script relies on.
//
// If the Afterpay app is updated to handle `option_values`-based requests, or to listen for
// a theme event, this file can be removed.

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const variantEvent = /** @type {import('@theme/events').VariantUpdateEvent} */ (event);
  const section = variantEvent.target instanceof Element ? variantEvent.target.closest('.shopify-section, dialog') : null;
  if (!section) return;

  const placement = section.querySelector('square-placement');
  if (!placement) return;

  const newPrice = variantEvent.detail.resource?.price;
  if (!newPrice) return;

  const newAmount = newPrice / 100;
  const currentAmount = parseFloat(placement.getAttribute('data-amount') ?? '0');
  if (Math.abs(currentAmount - newAmount) < 0.001) return;

  placement.setAttribute('data-amount', newAmount.toFixed(2));
});
